import React from 'react';

export const baseColors = [
  {
    id: 1,
    color: '#000',
    text: 'black'
  },
  {
    id: 2,
    color: '#fff',
    text: 'white'
  },
  {
    id: 3,
    color: '#5e89a9',
    text: 'squardron blue'
  },
  {
    id: 4,
    color: '#798753',
    text: 'battle green'
  },
  {
    id: 4,
    color: '#c1995f',
    text: 'desert storm'
  },
  {
    id: 5,
    color: '#4aa7da',
    text: 'electra blue'
  }
];

export const internalFabricColor = [
  {
    id: 1,
    color: '#656565',
    text: 'grey'
  },
  {
    id: 2,
    color: '#e02f2f',
    text: 'red'
  },
  {
    id: 3,
    color: '#8a6632',
    text: 'brown'
  }
];

export const viseColor = [
  {
    id: 1,
    color: '#fff',
    text: 'transparent'
  },
  {
    id: 2,
    color: '#ebc80a',
    text: 'yellow'
  }
  // {
  //   id: 3,
  //   color: '#fff',
  //   text: 'chrome'
  // }
];

export const visors = [
  {
    id: 1,
    icon: 'https://cdn.scapic.com/re-assets/icons/open-face.svg',
    text: 'chopper'
  },
  {
    id: 2,
    icon: 'https://cdn.scapic.com/re-assets/icons/urban-trooper.svg',
    text: 'peak',
    children: [
      {
        id: 1,
        color: '#000',
        text: 'black'
      },
      {
        id: 2,
        color: '#fff',
        text: 'white'
      }
    ]
  },
  {
    id: 3,
    icon: 'https://cdn.scapic.com/re-assets/icons/full-face.svg',
    text: 'bubble'
  }
];

export const textColors = [
  {
    id: 1,
    color: '#000',
    text: 'black'
  },
  {
    id: 2,
    color: '#fff',
    text: 'white'
  }
];

export const helmetTypes = [
  {
    id: 1,
    icon: 'https://cdn.scapic.com/re-assets/icons/open-face.svg',
    text: 'open face'
  },
  {
    id: 2,
    icon: 'https://cdn.scapic.com/re-assets/icons/urban-trooper.svg',
    text: 'urban trooper'
  },
  {
    id: 3,
    icon: 'https://cdn.scapic.com/re-assets/icons/full-face.svg',
    text: 'full face'
  }
];

export const colorPaneColors = [
  {
    id: 1,
    color: 'red',
    text: 'red'
  },
  {
    id: 2,
    color: 'black',
    text: 'black'
  }
];

export const decals = [
  {
    id: 1,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 2,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 3,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 4,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 5,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 6,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 7,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 8,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 1,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 2,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 3,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 4,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 5,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 6,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 7,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  },
  {
    id: 8,
    imageUrl: 'https://cdn.scapic.com/re-assets/images/re-logo.jpg'
  }
];

export const finishes = [
  {
    id: 1,
    text: 'matt',
    icon: 'https://cdn.scapic.com/re-assets/icons/matt.svg'
  },
  {
    id: 2,
    text: 'gloss',
    icon: 'https://cdn.scapic.com/re-assets/icons/gloss.svg'
  }
];

export const goggle = [
  {
    id: 1,
    icon: 'https://cdn.scapic.com/re-assets/icons/goggle.svg',
    text: 'goggle'
  }
];

export const categories = [
  {
    name: 'helmetType',
    label: 'Helmet Type',
    icon: 'https://reecommdev.blob.core.windows.net/re-assets/icons/helmet.svg',
    data: helmetTypes
  },
  {
    name: 'helmetColor',
    label: 'Helmet Color',
    icon: 'https://cdn.scapic.com/re-assets/icons/base-color.svg',
    data: baseColors
  },
  {
    name: 'decal',
    label: 'Decal',
    icon: 'https://cdn.scapic.com/re-assets/icons/decal.svg',
    data: decals
  },
  {
    name: 'fabricColor',
    label: 'Fabric Color',
    icon: 'https://cdn.scapic.com/re-assets/icons/internal-fabric-color.svg',
    data: internalFabricColor
  },
  {
    name: 'visor',
    label: 'Visor',
    icon: 'https://cdn.scapic.com/re-assets/icons/visor.svg',
    data: visors
  },
  {
    name: 'finish',
    label: 'Finish',
    icon: 'https://cdn.scapic.com/re-assets/icons/finish.svg',
    data: finishes
  },
  {
    name: 'visorColor',
    label: 'Visor Color',
    icon: 'https://cdn.scapic.com/re-assets/icons/visor-color.svg',
    data: viseColor
  },
  {
    name: 'text',
    label: 'Text',
    icon: 'https://cdn.scapic.com/re-assets/icons/text.svg',
    data: textColors
  },
  {
    name: 'goggle',
    label: 'Goggle',
    icon: 'https://cdn.scapic.com/re-assets/icons/goggle.svg',
    data: goggle
  }
];
